// Normalize API url: remove trailing slashes to avoid double // when concatenating
export const API_URL = (process.env.REACT_APP_API_URL || "http://localhost:80/api").replace(/\/+$/,'');
export const PYTHON_APP_API_URL = process.env.PYTHON_APP_API_URL || "http://localhost:3001";

// events
export const API_URL_EVENTS_LIST_EVENTS = API_URL+"/events/listEvents";
export const API_URL_EVENTS_SCRAPE_AND_SAVE = API_URL+"/events/scrapeAndSaveEvents";

// football matches
export const API_URL_FOOTBALL_LIST_MATCHES = API_URL+"/events/listMatches";
export const API_URL_FOOTBALL_SCRAPE_AND_SAVE = API_URL+"/events/scrapeAndSaveMatches";

// user
export const API_URL_USER_ISIDENTIFIED = API_URL+"/user/isIdentified";
export const API_URL_USER_LOGIN = API_URL+"/user/login";
export const API_URL_LIST_USERS = API_URL+"/user/listUsers";
export const API_URL_CREATE_USER = API_URL+"/user/createUser";
export const API_URL_DELETE_USER = API_URL+"/user/delete";
export const API_URL_UPDATE_USER = API_URL+"/user/update";
export const API_URL_LIST_ROLES = API_URL+"/user/listRoles";

// restaurant
// - Employees
export const API_URL_RESTAURANT_ADD_EMPLOYEE = API_URL+"/restaurant/employees/addEmployee";
export const API_URL_RESTAURANT_EDIT_EMPLOYEE = API_URL+"/restaurant/employees/editEmployee";
export const API_URL_RESTAURANT_DELETE_EMPLOYEEs = API_URL+"/restaurant/employees/deleteEmployees";
export const API_URL_RESTAURANT_ARCHIVE_EMPLOYEES = API_URL+"/restaurant/employees/archiveEmployees";
export const API_URL_RESTAURANT_ACTIVATE_EMPLOYEES = API_URL+"/restaurant/employees/activeEmployees";
export const API_URL_RESTAURANT_GET_EMPLOYEES = API_URL+"/restaurant/employees/getEmployees";
export const API_URL_RESTAURANT_GET_EMPLOYEES_WITH_FORMATIONS = API_URL+"/restaurant/employees/getEmployeesWithFormations";
export const API_URL_RESTAURANT_GET_EMPLOYEES_WITH_FORMATIONS_AND_AVAILABILITIES = API_URL+"/restaurant/employees/getEmployeesWithFormationsAndAvailabilities";
export const API_URL_RESTAURANT_GET_EMPLOYEE_WEEKLY_AVAILABILITIES = API_URL+"/restaurant/employees/getEmployeeWeeklyAvailabilities";
export const API_URL_RESTAURANT_GET_LEAVEDAYS_OF_EMPLOYEE = API_URL+"/restaurant/employees/getLeaveDaysOfEmployee";
export const API_URL_RESTAURANT_ADD_LEAVEDAYS_FOR_EMPLOYEE = API_URL+"/restaurant/employees/addLeaveDays";
export const API_URL_RESTAURANT_REMOVE_LEAVEDAYS_FOR_EMPLOYEE = API_URL+"/restaurant/employees/removeLeaveDays";
// - Formations
export const API_URL_RESTAURANT_UPSERT_FORMATION = API_URL+"/restaurant/formations/upsertFormation";
export const API_URL_RESTAURANT_DELETE_FORMATIONS = API_URL+"/restaurant/formations/deleteFormations";
export const API_URL_RESTAURANT_ASSIGN_FORMATIONS = API_URL+"/restaurant/formations/assignFormations";
export const API_URL_RESTAURANT_GET_FORMATIONS = API_URL+"/restaurant/formations/getFormations";
// - Data
export const API_URL_RESTAURANT_DELETE_DAILY_RESULTS = API_URL+"/restaurant/data/deleteDailyResults";
export const API_URL_RESTAURANT_TODAYS_DATA = API_URL+"/restaurant/data/todaysData";
// - Planning
export const API_URL_RESTAURANT_ADD_ABSENCES = API_URL+"/restaurant/planning/addAbsences";
export const API_URL_RESTAURANT_GET_PLANNING = API_URL+"/restaurant/planning/getPlanning";
export const API_URL_RESTAURANT_SAVE_PLANNING_CHANGES = API_URL+"/restaurant/planning/savePlanningChanges";
export const API_URL_RESTAURANT_GENERATE_PLANNING = API_URL+"/restaurant/planning/generatePlanning";
export const API_URL_RESTAURANT_DOWNLOAD_PLANNING = API_URL+"/restaurant/planning/downloadPlanningPdf";
export const API_URL_RESTAURANT_DELETE_PLANNING_CHANGES = API_URL+"/restaurant/planning/deletePlanningChanges";
export const API_URL_RESTAURANT_EMPLOYEE_NOT_WORKINGS = API_URL+"/restaurant/planning/EmployeeNotWorkings";
export const API_URL_RESTAURANT_ADD_WORK_DAYS_FOR_EMPLOYEES = API_URL+"/restaurant/planning/AddWorkDaysForEmployees";
export const API_URL_RESTAURANT_DELETE_PLANNING_WEEK = API_URL+"/restaurant/planning/deleteWeeklyPlanning";
// - Planning Forecast
export const API_URL_RESTAURANT_GET_WEEKLY_PLANNING_FORECASTS = API_URL+"/restaurant/planning-forecast/getWeeklyPlanningForecasts";
export const API_URL_RESTAURANT_UPSERT_WEEKLY_PLANNING_FORECASTS = API_URL+"/restaurant/planning-forecast/upsertWeeklyPlanningForecast";
export const API_URL_RESTAURANT_DELETE_WEEKLY_PLANNING_FORECAST = API_URL+"/restaurant/planning-forecast/deleteWeeklyPlanningForecast";
export const API_URL_RESTAURANT_REGENERATE_WEEKLY_PLANNING_FORECASTS = API_URL+"/restaurant/planning-forecast/regenerateWeeklyPlanningForecasts";
export const API_URL_RESTAURANT_DELETE_PLANNING_FORECAST_WEEK = API_URL+"/restaurant/planning-forecast/deleteWeeklyPlanningForecast";

//open ai
export const API_URL_OPENAI_PROMPT = API_URL+"/openai/prompt";

// performance
// performance endpoints: API_URL already contains the /api prefix
export const API_URL_PERFORMANCE = API_URL + "/performance";
export const API_URL_RESTAURANT_TODAYS_FORECAST = API_URL + "/performance/todaysStats";

// parametres
export const API_URL_RESTAURANT_DELETE_PARAMETRES = API_URL+"/restaurant/parametres/deleteParametres";
export const API_URL_RESTAURANT_GET_PARAMETRES = API_URL+"/restaurant/parametres/getParametres";
export const API_URL_RESTAURANT_UPSERT_PARAMETRES = API_URL+"/restaurant/parametres/upsertParametres";